import { Project as IProject, Client, Character, IActor } from '@types';

import * as moment from 'moment';

export class ProjectModel implements IProject {
    id: number = null;
    nazov: string = null;
    zaciatok: Date = null;
    vytvoril: string = '';
    schvaleny: boolean = false;
    na_schvalenie: boolean = false;
    characters: Character[] = [];
    detail: any;
    klient: Client;
    id_klient: number = null;
    schvalenie_email: string = '';
    schvalil: string = '';
    datum_odoslane: Date = null;
    odoslal: string = '';
    datum_schvalenia: Date = null;
    hasOrder: boolean = false;
    zobrazit_do: Date = null;
    blacklist: IActor[] = [];
    blacklist_ids: [] = [];
    prolongs: [] = [];
    order: {} = {};
    status: string = '';
    directorscut_url: string = '';

    constructor({
        id,
        nazov,
        zaciatok,
        vytvoril,
        klient,
        characters,
        id_klient,
        detail,
        schvaleny,
        na_schvalenie,
        schvalenie_email,
        schvalil,
        datum_odoslane,
        odoslal,
        datum_schvalenia,
        hasOrder,
        zobrazit_do,
        blacklist,
        blacklist_ids,
        prolongs,
        order,
        status,
        directorscut_url,
    }: IProject) {
        this.id = id;
        this.nazov = nazov;
        this.characters = characters;
        this.zaciatok = zaciatok;
        this.vytvoril = vytvoril;
        this.detail = detail;
        this.klient = klient;
        this.id_klient = id_klient;
        this.schvaleny = schvaleny;
        this.na_schvalenie = na_schvalenie;
        this.schvalenie_email = schvalenie_email;
        this.schvalil = schvalil;
        this.datum_odoslane = datum_odoslane;
        this.odoslal = odoslal;
        this.datum_schvalenia = datum_schvalenia;
        this.hasOrder = hasOrder;
        this.zobrazit_do = zobrazit_do;
        this.blacklist = blacklist;
        this.blacklist_ids = blacklist_ids;
        this.prolongs = prolongs;
        this.order = order;
        this.status = status;
        this.directorscut_url = directorscut_url;
    }
}
